"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isValidI18nKey = _interopRequireDefault(require("I18n/utils/isValidI18nKey"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H4"));

var _UIBreakString = _interopRequireDefault(require("UIComponents/text/UIBreakString"));

var _ReviewSection = _interopRequireDefault(require("../../components/reviews/ReviewSection"));

var ReviewQuestions = _interopRequireWildcard(require("../../constants/reviews/ReviewQuestions"));

var _dummyReviews = require("../../constants/reviews/dummyReviews");

var _Review = _interopRequireDefault(require("../../records/Review"));

var ReviewBody = function ReviewBody(_ref) {
  var review = _ref.review,
      className = _ref.className;
  var answers = review.get('answers').toJS();

  var renderReviewSection = function renderReviewSection(question) {
    var answer = answers[question];
    var textKey = "ecosystemMarketplaceCore.reviews.responses." + question;

    var title = (0, _isValidI18nKey.default)(textKey) && _react.default.createElement(_FormattedMessage.default, {
      message: textKey
    });

    var AnswerTextComponent = question === ReviewQuestions.TITLE ? _H.default : 'span';
    return _react.default.createElement(_ReviewSection.default, {
      key: question,
      title: title
    }, _react.default.createElement(AnswerTextComponent, null, _react.default.createElement(_UIBreakString.default, null, answer)));
  };

  return _react.default.createElement("div", {
    className: className
  }, ReviewQuestions.QuestionOrder.map(function (question) {
    return answers[question] && renderReviewSection(question);
  }));
};

ReviewBody.propTypes = {
  className: _propTypes.default.string,
  review: _propTypes.default.instanceOf(_Review.default).isRequired
}; // TODO remove

ReviewBody.defaultProps = {
  review: _dummyReviews.review2
};
var _default = ReviewBody;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/reviews/ReviewBody.js
// module id = 285
// module chunks = 209 210 211 212